import { render, staticRenderFns } from "./FinancialMenu.vue?vue&type=template&id=dc630520"
import script from "./FinancialMenu.vue?vue&type=script&lang=js"
export * from "./FinancialMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports